// extracted by mini-css-extract-plugin
module.exports = {"root":"auth_root_2yVYA","container":"auth_container_2jnsv","icon":"auth_icon_1N_PW","content":"auth_content_c8MzD","contentSupport":"auth_contentSupport_3MCUe"};